import { chartEmptyValueConstants } from '@/utils/reports/chartEmptyValueConstants';

const emptyKeyMap = {
  requisitions_by_department_pie: 'department',
  requisitions_by_requisition_type_pie: 'requisition_type',
};

// Map tile keys to their corresponding metric index in the data array
const metricIndexMap = {
  requisitions_by_department_pie: 5, // requisitions_filled index
  requisitions_by_requisition_type_pie: 5, // requisitions_filled index
};

/**
 * Transforms requisitions data for pie charts
 * @param response API response data
 * @param metadata Metadata containing tileKey
 * @returns Object containing series and categories for pie chart
 */
export const requisitionsPieTransformer = ({ response, metadata }) => {
  const { table = [], lookups: { g1 = [] } = {} } = response || {};

  const { tileKey } = metadata || {};
  const emptyKey = emptyKeyMap[tileKey];
  const metricIndex = metricIndexMap[tileKey] || 4; // Default to requisitions_opened (index 4)

  const formattedData = table?.map((row) => {
    const groupIndex = row[2]; // g1 is at index 2
    const value = row[metricIndex]; // Get the value based on metric index

    if (Array.isArray(g1[groupIndex])) {
      // Handle array type g1 values (if applicable)
      const nameLookup = g1[groupIndex]
        ?.map((item) => item?.name)
        .filter(Boolean);
      return { value, name: nameLookup?.join(', ') };
    }

    if (typeof g1[groupIndex] === 'object' && g1[groupIndex] !== null) {
      // Handle object type g1 values
      return { value, ...g1[groupIndex] };
    }

    // Handle primitive or undefined values
    return { value, key: g1[groupIndex] };
  });

  // Format data for pie chart
  const series = [];
  const categories = [];

  formattedData?.forEach((item) => {
    const displayName =
      item?.name || chartEmptyValueConstants[emptyKey] || 'Not found';

    series.push({
      name: displayName,
      y: item?.value,
      g1: item?.id || null,
    });
    categories.push(displayName);
  });

  return {
    series,
    categories,
  };
};
